import { BaseImage, Options, PayloadImageProps } from "./types";

type GetImageSize =
  | {
      width: number;
      url: string;
    }
  | undefined;

export const typeToObjectFitMap: {
  [key in NonNullable<BaseImage["type"]>]: Options["size"];
} = {
  Decorative: "cover",
  Descriptive: "contain"
};

export const getPosition = ({
  size,
  position,
  focalX,
  focalY,
  isMobile
}: Options & Pick<BaseImage, "focalX" | "focalY">): Options["position"] => {
  if (position) {
    return position;
  }

  if (!isMobile && size === "cover" && focalX && focalY) {
    return `${focalX}% ${focalY}%`;
  }

  return "center";
};

export const getMobileSize = (
  sizes: PayloadImageProps["sizes"]
): GetImageSize => {
  if ("cardMobile" in sizes && sizes.cardMobile.url && sizes.cardMobile.width) {
    return { width: sizes.cardMobile.width, url: sizes.cardMobile.url };
  }
  if (
    "documentMobile" in sizes &&
    sizes.documentMobile.url &&
    sizes.documentMobile.width
  ) {
    return { width: sizes.documentMobile.width, url: sizes.documentMobile.url };
  }
  if (
    "gallerySlideMobile" in sizes &&
    sizes.gallerySlideMobile.url &&
    sizes.gallerySlideMobile.width
  ) {
    return {
      width: sizes.gallerySlideMobile.width,
      url: sizes.gallerySlideMobile.url
    };
  }
  if (
    "headerMobile" in sizes &&
    sizes.headerMobile.url &&
    sizes.headerMobile.width
  ) {
    return { width: sizes.headerMobile.width, url: sizes.headerMobile.url };
  }
  if ("heroMobile" in sizes && sizes.heroMobile.width && sizes.heroMobile.url) {
    return { width: sizes.heroMobile.width, url: sizes.heroMobile.url };
  }
  if (
    "richTextMobile" in sizes &&
    sizes.richTextMobile.width &&
    sizes.richTextMobile.url
  ) {
    return { width: sizes.richTextMobile.width, url: sizes.richTextMobile.url };
  }
  if (
    "slideMobile" in sizes &&
    sizes.slideMobile.width &&
    sizes.slideMobile.url
  ) {
    return { width: sizes.slideMobile.width, url: sizes.slideMobile.url };
  }
  if (
    "trainingDetailMobile" in sizes &&
    sizes.trainingDetailMobile.width &&
    sizes.trainingDetailMobile.url
  ) {
    return {
      width: sizes.trainingDetailMobile.width,
      url: sizes.trainingDetailMobile.url
    };
  }
  if (
    "videoMobile" in sizes &&
    sizes.videoMobile.width &&
    sizes.videoMobile.url
  ) {
    return { width: sizes.videoMobile.width, url: sizes.videoMobile.url };
  }
  if (
    "villainMobile" in sizes &&
    sizes.villainMobile.width &&
    sizes.villainMobile.url
  ) {
    return { width: sizes.villainMobile.width, url: sizes.villainMobile.url };
  }

  return undefined;
};

export const getTabletPortraitSize = (
  sizes: PayloadImageProps["sizes"]
): GetImageSize => {
  if (
    "cardTabletPortrait" in sizes &&
    sizes.cardTabletPortrait.width &&
    sizes.cardTabletPortrait.url
  ) {
    return {
      width: sizes.cardTabletPortrait.width,
      url: sizes.cardTabletPortrait.url
    };
  }
  if (
    "documentTabletPortrait" in sizes &&
    sizes.documentTabletPortrait.width &&
    sizes.documentTabletPortrait.url
  ) {
    return {
      width: sizes.documentTabletPortrait.width,
      url: sizes.documentTabletPortrait.url
    };
  }
  if (
    "gallerySlideTabletPortrait" in sizes &&
    sizes.gallerySlideTabletPortrait.width &&
    sizes.gallerySlideTabletPortrait.url
  ) {
    return {
      width: sizes.gallerySlideTabletPortrait.width,
      url: sizes.gallerySlideTabletPortrait.url
    };
  }
  if (
    "headerTabletPortrait" in sizes &&
    sizes.headerTabletPortrait.width &&
    sizes.headerTabletPortrait.url
  ) {
    return {
      width: sizes.headerTabletPortrait.width,
      url: sizes.headerTabletPortrait.url
    };
  }
  if (
    "heroTabletPortrait" in sizes &&
    sizes.heroTabletPortrait.width &&
    sizes.heroTabletPortrait.url
  ) {
    return {
      width: sizes.heroTabletPortrait.width,
      url: sizes.heroTabletPortrait.url
    };
  }
  if (
    "richTextTabletPortrait" in sizes &&
    sizes.richTextTabletPortrait.width &&
    sizes.richTextTabletPortrait.url
  ) {
    return {
      width: sizes.richTextTabletPortrait.width,
      url: sizes.richTextTabletPortrait.url
    };
  }
  if (
    "slideTabletPortrait" in sizes &&
    sizes.slideTabletPortrait.width &&
    sizes.slideTabletPortrait.url
  ) {
    return {
      width: sizes.slideTabletPortrait.width,
      url: sizes.slideTabletPortrait.url
    };
  }
  if (
    "trainingDetailTabletPortrait" in sizes &&
    sizes.trainingDetailTabletPortrait.width &&
    sizes.trainingDetailTabletPortrait.url
  ) {
    return {
      width: sizes.trainingDetailTabletPortrait.width,
      url: sizes.trainingDetailTabletPortrait.url
    };
  }
  if (
    "videoTabletPortrait" in sizes &&
    sizes.videoTabletPortrait.width &&
    sizes.videoTabletPortrait.url
  ) {
    return {
      width: sizes.videoTabletPortrait.width,
      url: sizes.videoTabletPortrait.url
    };
  }
  if (
    "villainTabletPortrait" in sizes &&
    sizes.villainTabletPortrait.width &&
    sizes.villainTabletPortrait.url
  ) {
    return {
      width: sizes.villainTabletPortrait.width,
      url: sizes.villainTabletPortrait.url
    };
  }
  return undefined;
};

export const getTabletLandscapeSize = (
  sizes: PayloadImageProps["sizes"]
): GetImageSize => {
  if (
    "cardTabletLandscape" in sizes &&
    sizes.cardTabletLandscape.width &&
    sizes.cardTabletLandscape.url
  ) {
    return {
      width: sizes.cardTabletLandscape.width,
      url: sizes.cardTabletLandscape.url
    };
  }
  if (
    "documentTabletLandscape" in sizes &&
    sizes.documentTabletLandscape.width &&
    sizes.documentTabletLandscape.url
  ) {
    return {
      width: sizes.documentTabletLandscape.width,
      url: sizes.documentTabletLandscape.url
    };
  }
  if (
    "gallerySlideTabletLandscape" in sizes &&
    sizes.gallerySlideTabletLandscape.width &&
    sizes.gallerySlideTabletLandscape.url
  ) {
    return {
      width: sizes.gallerySlideTabletLandscape.width,
      url: sizes.gallerySlideTabletLandscape.url
    };
  }
  if (
    "headerTabletLandscape" in sizes &&
    sizes.headerTabletLandscape.width &&
    sizes.headerTabletLandscape.url
  ) {
    return {
      width: sizes.headerTabletLandscape.width,
      url: sizes.headerTabletLandscape.url
    };
  }
  if (
    "heroTabletLandscape" in sizes &&
    sizes.heroTabletLandscape.width &&
    sizes.heroTabletLandscape.url
  ) {
    return {
      width: sizes.heroTabletLandscape.width,
      url: sizes.heroTabletLandscape.url
    };
  }
  if (
    "richTextTabletLandscape" in sizes &&
    sizes.richTextTabletLandscape.width &&
    sizes.richTextTabletLandscape.url
  ) {
    return {
      width: sizes.richTextTabletLandscape.width,
      url: sizes.richTextTabletLandscape.url
    };
  }
  if (
    "slideTabletLandscape" in sizes &&
    sizes.slideTabletLandscape.width &&
    sizes.slideTabletLandscape.url
  ) {
    return {
      width: sizes.slideTabletLandscape.width,
      url: sizes.slideTabletLandscape.url
    };
  }
  if (
    "trainingDetailTabletLandscape" in sizes &&
    sizes.trainingDetailTabletLandscape.width &&
    sizes.trainingDetailTabletLandscape.url
  ) {
    return {
      width: sizes.trainingDetailTabletLandscape.width,
      url: sizes.trainingDetailTabletLandscape.url
    };
  }
  if (
    "videoTabletLandscape" in sizes &&
    sizes.videoTabletLandscape.width &&
    sizes.videoTabletLandscape.url
  ) {
    return {
      width: sizes.videoTabletLandscape.width,
      url: sizes.videoTabletLandscape.url
    };
  }
  if (
    "villainTabletLandscape" in sizes &&
    sizes.villainTabletLandscape.width &&
    sizes.villainTabletLandscape.url
  ) {
    return {
      width: sizes.villainTabletLandscape.width,
      url: sizes.villainTabletLandscape.url
    };
  }
  return undefined;
};

export const getLaptopSize = (
  sizes: PayloadImageProps["sizes"]
): GetImageSize => {
  if ("cardLaptop" in sizes && sizes.cardLaptop.width && sizes.cardLaptop.url) {
    return { width: sizes.cardLaptop.width, url: sizes.cardLaptop.url };
  }
  if (
    "documentLaptop" in sizes &&
    sizes.documentLaptop.width &&
    sizes.documentLaptop.url
  ) {
    return { width: sizes.documentLaptop.width, url: sizes.documentLaptop.url };
  }
  if (
    "gallerySlideLaptop" in sizes &&
    sizes.gallerySlideLaptop.width &&
    sizes.gallerySlideLaptop.url
  ) {
    return {
      width: sizes.gallerySlideLaptop.width,
      url: sizes.gallerySlideLaptop.url
    };
  }
  if (
    "headerLaptop" in sizes &&
    sizes.headerLaptop.width &&
    sizes.headerLaptop.url
  ) {
    return { width: sizes.headerLaptop.width, url: sizes.headerLaptop.url };
  }
  if ("heroLaptop" in sizes && sizes.heroLaptop.width && sizes.heroLaptop.url) {
    return { width: sizes.heroLaptop.width, url: sizes.heroLaptop.url };
  }
  if (
    "richTextLaptop" in sizes &&
    sizes.richTextLaptop.width &&
    sizes.richTextLaptop.url
  ) {
    return { width: sizes.richTextLaptop.width, url: sizes.richTextLaptop.url };
  }
  if (
    "slideLaptop" in sizes &&
    sizes.slideLaptop.width &&
    sizes.slideLaptop.url
  ) {
    return { width: sizes.slideLaptop.width, url: sizes.slideLaptop.url };
  }
  if (
    "trainingDetailLaptop" in sizes &&
    sizes.trainingDetailLaptop.width &&
    sizes.trainingDetailLaptop.url
  ) {
    return {
      width: sizes.trainingDetailLaptop.width,
      url: sizes.trainingDetailLaptop.url
    };
  }
  if (
    "videoLaptop" in sizes &&
    sizes.videoLaptop.width &&
    sizes.videoLaptop.url
  ) {
    return { width: sizes.videoLaptop.width, url: sizes.videoLaptop.url };
  }
  if (
    "villainLaptop" in sizes &&
    sizes.villainLaptop.width &&
    sizes.villainLaptop.url
  ) {
    return { width: sizes.villainLaptop.width, url: sizes.villainLaptop.url };
  }
  return undefined;
};

export const getDesktopSize = (
  sizes: PayloadImageProps["sizes"]
): GetImageSize => {
  if (
    "cardDesktop" in sizes &&
    sizes.cardDesktop.width &&
    sizes.cardDesktop.url
  ) {
    return { width: sizes.cardDesktop.width, url: sizes.cardDesktop.url };
  }
  if (
    "documentDesktop" in sizes &&
    sizes.documentDesktop.width &&
    sizes.documentDesktop.url
  ) {
    return {
      width: sizes.documentDesktop.width,
      url: sizes.documentDesktop.url
    };
  }
  if (
    "gallerySlideDesktop" in sizes &&
    sizes.gallerySlideDesktop.width &&
    sizes.gallerySlideDesktop.url
  ) {
    return {
      width: sizes.gallerySlideDesktop.width,
      url: sizes.gallerySlideDesktop.url
    };
  }
  if (
    "headerDesktop" in sizes &&
    sizes.headerDesktop.width &&
    sizes.headerDesktop.url
  ) {
    return { width: sizes.headerDesktop.width, url: sizes.headerDesktop.url };
  }
  if (
    "heroDesktop" in sizes &&
    sizes.heroDesktop.width &&
    sizes.heroDesktop.url
  ) {
    return { width: sizes.heroDesktop.width, url: sizes.heroDesktop.url };
  }
  if (
    "richTextDesktop" in sizes &&
    sizes.richTextDesktop.width &&
    sizes.richTextDesktop.url
  ) {
    return {
      width: sizes.richTextDesktop.width,
      url: sizes.richTextDesktop.url
    };
  }
  if (
    "slideDesktop" in sizes &&
    sizes.slideDesktop.width &&
    sizes.slideDesktop.url
  ) {
    return { width: sizes.slideDesktop.width, url: sizes.slideDesktop.url };
  }
  if (
    "trainingDetailDesktop" in sizes &&
    sizes.trainingDetailDesktop.width &&
    sizes.trainingDetailDesktop.url
  ) {
    return {
      width: sizes.trainingDetailDesktop.width,
      url: sizes.trainingDetailDesktop.url
    };
  }
  if (
    "videoDesktop" in sizes &&
    sizes.videoDesktop.width &&
    sizes.videoDesktop.url
  ) {
    return { width: sizes.videoDesktop.width, url: sizes.videoDesktop.url };
  }
  if (
    "villainDesktop" in sizes &&
    sizes.villainDesktop.width &&
    sizes.villainDesktop.url
  ) {
    return { width: sizes.villainDesktop.width, url: sizes.villainDesktop.url };
  }
  return undefined;
};

export const getProfileSize = (
  sizes: PayloadImageProps["sizes"]
): GetImageSize => {
  if ("profile" in sizes && sizes.profile.width && sizes.profile.url) {
    return { width: sizes.profile.width, url: sizes.profile.url };
  }
};
